// extracted by mini-css-extract-plugin
export default {"headAdminPage":"headadminlocationpage_headAdminPage__CPYx1","first":"headadminlocationpage_first__5Tr8M","send":"headadminlocationpage_send__VWV0i"};